import { render } from "./ModalUpdateRRIM.vue?vue&type=template&id=5113536a&scoped=true"
import script from "./ModalUpdateRRIM.vue?vue&type=script&lang=js"
export * from "./ModalUpdateRRIM.vue?vue&type=script&lang=js"

import "./ModalUpdateRRIM.vue?vue&type=style&index=0&id=5113536a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5113536a"]])

export default __exports__